// extracted by mini-css-extract-plugin
export default {"Root":"ImageSection_Root__HtV+O","ImageItem":"ImageSection_ImageItem__06h3Z"};